import _ from 'underscore';

import { AllowedGridEntityTypes } from './constant';
import { ViewTracker } from './trackers/view-tracker';

const trackerFactory = (type, options, deps = {}) => {
  const mixedOptions = _.defaults(options, deps);

  let tracker = null;

  switch (type) {
    case 'ViewTracker':
      tracker = new ViewTracker(mixedOptions);
      break;

    default:
      // eslint-disable-next-line
      console.error(`Unsupported tracker type ${type}`);
  }

  return tracker;
};

export const trackingPlugin = definePlugin => definePlugin('tracking', [
  'config',
  'gridView',
], (config, gridView) => {
  const {
    trackers: trackerOptions,
    entityType,
    enabled = false,
  } = _.result(config.plugins, 'tracking', {});

  let trackers = [];

  const entityTypeAllowed = _.contains(AllowedGridEntityTypes, entityType);

  if (false && enabled && entityTypeAllowed) {
    const Instrumentation = null;
    const scenario = Instrumentation.mainlineGrid.create();
    const commonDeps = { entityType, gridView, logScenario: scenario };

    trackers = _.compact(_.map(
      trackerOptions,
      (options, type) => trackerFactory(type, options, commonDeps)
    ));
  }

  return {
    remove: () => {
      _.each(trackers, x => x.close());
    },
  };
});
